import { gql } from '@apollo/client';

export const QUERY_DASHBOARD_MARK_RULES = gql`
    query QueryDashboardMarkRules($dashboardKey: String!) {
        queryDashboardMarkRules(dashboardKey: $dashboardKey) {
            fieldName
            columnOffset
            columnOffsetEnd
            rowScope
            includeDrillDown
            targetOperator
            targetValue
            womOperator
            womValue
        }
    }
`;
